export const projectResaleReducer = (
  state = {
    projectResaleList: null,
    projectResaleDetail: null,
    propertyResaleList: null,
    resaleInterestedProjectList: null,
    detailLoading: false,
    loading: false,
    listLoading: false,
    error: null,
  },
  action
) => {
  switch (action.type) {
    case "ADD_PROJECT_RESALE_REQUEST":
      return { ...state, loading: true, error: null };
    case "ADD_PROJECT_RESALE_SUCCESS":
      return { ...state, loading: false, error: null };
    case "ADD_PROJECT_RESALE_FAILED":
      return { ...state, loading: false, error: action.payload };

    case "LIST_PROJECT_RESALE_REQUEST":
      return { ...state, listLoading: true, error: null };
    case "LIST_PROJECT_RESALE_SUCCESS":
      return {
        ...state,
        listLoading: false,
        projectResaleList: action.payload,
        error: null,
      };
    case "LIST_PROJECT_RESALE_FAILED":
      return { ...state, listLoading: false, error: action.payload };

    case "VIEW_PROJECT_RESALE_REQUEST":
      return { ...state, detailLoading: true, error: null };
    case "VIEW_PROJECT_RESALE_SUCCESS":
      return {
        ...state,
        detailLoading: false,
        projectResaleDetail: action.payload,
        error: null,
      };
    case "VIEW_PROJECT_RESALE_FAILED":
      return { ...state, detailLoading: false, error: action.payload };

    case "UPDATE_PROJECT_RESALE_REQUEST":
      return { ...state, loading: true, error: null };
    case "UPDATE_PROJECT_RESALE_SUCCESS":
      return { ...state, loading: false, error: null };
    case "UPDATE_PROJECT_RESALE_FAILED":
      return { ...state, loading: false, error: action.payload };

    case "STATUS_PROJECT_RESALE_REQUEST":
      return { ...state, loading: true, error: null };
    case "STATUS_PROJECT_RESALE_SUCCESS":
      return { ...state, loading: false, error: null };
    case "STATUS_PROJECT_RESALE_FAILED":
      return { ...state, loading: false, error: action.payload };

    case "PROJECT_PROPERTY_LINK_RESALE_REQUEST":
      return { ...state, loading: true, error: null };
    case "PROJECT_PROPERTY_LINK_RESALE_SUCCESS":
      return {
        ...state,
        loading: false,
        error: null,
        projectResaleDetail: state.projectResaleDetail
          ? {
            ...state.projectResaleDetail,
            data: action.payload?.data || state.projectResaleDetail?.data,
          }
          : state.projectResaleDetail,
      };
    case "PROJECT_PROPERTY_LINK_RESALE_FAILED":
      return { ...state, loading: false, error: action.payload };

    case "UPDATE_PROJECT_PROPERTY_LINK_RESALE_REQUEST":
      return { ...state, loading: true, error: null };
    case "UPDATE_PROJECT_PROPERTY_LINK_RESALE_SUCCESS":
      return {
        ...state,
        loading: false,
        error: null,
        projectResaleDetail: state.projectResaleDetail
          ? {
            ...state.projectResaleDetail,
            data: action.payload?.data || state.projectResaleDetail?.data,
          }
          : state.projectResaleDetail,
      };
    case "UPDATE_PROJECT_PROPERTY_LINK_RESALE_FAILED":
      return { ...state, loading: false, error: action.payload };

    case "LIST_PROPERTY_RESALE_REQUEST":
      return { ...state, listLoading: true, error: null };
    case "LIST_PROPERTY_RESALE_SUCCESS":
      return {
        ...state,
        listLoading: false,
        propertyResaleList: action.payload,
        error: null,
      };
    case "LIST_PROPERTY_RESALE_FAILED":
      return { ...state, listLoading: false, error: action.payload };

    case "LIST_RESALE_INTERESTED_PROJECT_REQUEST":
      return { ...state, listLoading: true, error: null };
    case "LIST_RESALE_INTERESTED_PROJECT_SUCCESS":
      return {
        ...state,
        listLoading: false,
        resaleInterestedProjectList: action.payload,
        error: null,
      };
    case "LIST_RESALE_INTERESTED_PROJECT_FAILED":
      return { ...state, listLoading: false, error: action.payload };

    case "UPDATE_STATUS_RESALE_INTERESTED_PROJECT_REQUEST":
      return { ...state, loading: true, error: null };
    case "UPDATE_STATUS_RESALE_INTERESTED_PROJECT_SUCCESS":
      return { ...state, loading: false, error: null };
    case "UPDATE_STATUS_RESALE_INTERESTED_PROJECT_FAILED":
      return { ...state, loading: false, error: action.payload };
    case "SYNC_PROJECT_PROPERTY_LINK_RESALE_REQUEST":
      return { ...state, loading: true, error: null };
    case "SYNC_PROJECT_PROPERTY_LINK_RESALE_SUCCESS":
      return {
        ...state,
        loading: false,
        error: null,
        projectResaleDetail: state.projectResaleDetail
          ? {
            ...state.projectResaleDetail,
            data: action.payload?.data || state.projectResaleDetail?.data,
          }
          : state.projectResaleDetail,
      };
    case "SYNC_PROJECT_PROPERTY_LINK_RESALE_FAILED":
      return { ...state, loading: false, error: action.payload };
    case "GET_ENQUIRIES_LIST_REQUEST": {
      return {
        ...state,
        loading: true,
        enquiries: null,
      };
    }
    case "GET_ENQUIRIES_LIST_SUCCESS": {
      return {
        ...state,
        loading: false,
        enquiries: action.payload.data,
      };
    }
    case "GET_ENQUIRIES_LIST_FAILED": {
      return {
        ...state,
        loading: false,
        enquiries: action.payload,
      };
    }

    case "UPDATE_PROJECT_IS_POPULAR_REQUEST":
      return { ...state, loading: true, error: null };

    case "UPDATE_PROJECT_IS_POPULAR_SUCCESS":
      return { ...state, loading: false, error: null };

    case "UPDATE_PROJECT_IS_POPULAR_FAILED":
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};